// removed by extract-text-webpack-plugin
module.exports = {"component":"Ca7x_ASm _3vV4dgqW _1uSaxYl4","close":"_31de795J","link":"_1zu_8imr _3Jr8Ub72 _391P90pM"};


/*****************
 ** WEBPACK FOOTER
 ** ./site/menu.scss
 ** module id = 9
 ** module chunks = 0
 **/